/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect, useState } from "react";

const enum fields {
    jsScriptCode = "jsScriptCode",
}

interface Props extends WidgetProps {
    fields: {
        [fields.jsScriptCode]: string;
    };
}

export const AddJsCodeToHead: React.FunctionComponent<Props> = props => {

    const [isLoaded, setIsLoaded] = useState(false);
    const headJsCodeId = 'head_javascript_code';
    const jsScriptCode = props.fields.jsScriptCode;
    useEffect(() => {
        if (!document.getElementById(headJsCodeId)) {
            loadScript();
        } else {
            setIsLoaded(false);
        }
    }, [jsScriptCode]);

    const loadScript = () => {
        document.head.insertAdjacentHTML('beforeend', jsScriptCode);
    };
    return <></>;
};

const widgetModule: WidgetModule = {
    component: AddJsCodeToHead,
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.jsScriptCode,
                editorTemplate: "TextField",
                displayName: "JavaScript Code",
                defaultValue: "<script src='https://cdn.userway.org/widget.js?account=m5vTebT2iV'></script> <script src='https://cdn.userconsent.org/user_consent.js' data-user-consent-account='m5vTebT2iV'></script>",
            },
        ],
    },
};
export default widgetModule;